export default __webpack_public_path__ + "static/media/patio-res1.36adb635.jpg";